import { SectionName, SideNavIcon } from "./StyledComponents"

export function Section({ name }) {
  function openSideNav() {
    document.getElementById("mySidenav").style.width = "300px";
    document.getElementById("main").style.marginLeft = "300px";
  }

  return (
    <SectionName>
      <SideNavIcon
        onClick={openSideNav}
      >
        &#9776;
      </SideNavIcon>
      {name}
    </SectionName>
  )
}